/**
 * An awaited `form.validateFields()` rejects with antd's `{ errorFields, values, outOfDate }`
 * when a field is invalid. The form already shows the inline error, so the rejection is expected
 * flow, not a crash.
 */
export const FORM_VALIDATION_ERROR_PATTERNS = [/Object captured as promise rejection with keys: errorFields/];

/**
 * mixpanel-browser opens IndexedDB on every init to look for unsent session recordings, even
 * with recording off, and its `onupgradeneeded` handler reads `objectStoreNames` off the
 * database the event carries. Some iOS in-app web views (WKWebView) fire that event without a
 * database, so the handler throws inside the library where nothing of ours can catch it
 * (DASHBOARD-WEB-14, /login). No config skips the check short of `disable_persistence`, which
 * would also drop mixpanel's localStorage identity. The variable name is the minifier's; no code
 * of ours touches IndexedDB.
 */
export const INDEXED_DB_UNAVAILABLE_PATTERNS = [/^undefined is not an object \(evaluating '\w+\.objectStoreNames'\)$/];

/**
 * The Redux state attached to every Sentry event. Only UI state and the ids of the current
 * tenant: the entity slices and RTK Query caches hold owner, customer and bank details.
 */
export function sentryReduxState(state) {
  if (!state) {
    return null;
  }

  return {
    activeTab: state.activeTab,
    appStatus: state.appStatus,
    sideBar: state.sideBar,
    currentCompanyId: state.currentCompany?.company?.id ?? null,
    currentFranchiseId: state.currentFranchise?.franchise?.id ?? null,
    currentServiceProviderId: state.currentServiceProvider?.serviceProvider?.id ?? null,
  };
}
